<template>
    <div>
        <!-- como incorporar lo siguiente a v-if (user.user_data.products ? user.user_data.products.sports : true) -->
        <div v-show="infoRouter?.active" :style="'height:' + contentHeight + ';'" class="holds-the-iframe"
            style="overflow: hidden;">
            <iframe :style="'height:' + contentHeight + ';'" id="sports_iframe" :src="urlview" allowfullscreen
                allow="fullscreen" :key="reloadIframe"></iframe>
            <!-- <iframe v-else :style="'height:' + contentHeight + ';'" id="sports_iframe2"
                :src="selected_skin.sports_config.url + (user.token ? '&auth_token=' + user.token : '') + '&language=' + (language ?? '')"
                :key2="reloadIframe"></iframe> -->
        </div>
        <a v-if="selected_skin.whats_app_mainframe && selected_skin.whats_app_mainframe.enabled"
            :href="'https://api.whatsapp.com/send?phone=' + selected_skin.whats_app_mainframe.phone_number"
            id="whatsapp_btn" class="float btn" target="_blank" :style="finalStyle">
            <img id="whatsapp_logo" class="" src="../assets/images/whatsappBtn.png" alt="" width="45px">
        </a>
        <a v-if="selected_skin.telegram_mainframe && selected_skin.telegram_mainframe.enabled"
            :href="selected_skin.telegram_mainframe.url" id="whatsapp_btn" class="float btn" target="_blank"
            :style="screen_width > selected_skin.break_point ? 'bottom:45px;right:20px;position:fixed;z-index:9999;' : 'bottom: 68px;position: fixed;z-index: 9999;left: 5px;'">
            <img id="whatsapp_logo" class="" src="../assets/images/telegram.png" alt="" width="45px">
        </a>
    </div>
</template>

<script>
export default {
    name: 'Main',
    components: {

    },
    data() {
        return {
            refreshHeight: 0,
            screen_width: 0
        }
    },
    computed: {
        finalStyle() {
            const baseStyle =
                this.screen_width > this.selected_skin.break_point
                    ? {
                        bottom: "45px",
                        right: "20px",
                        position: "fixed",
                        "z-index": 9999,
                    }
                    : {
                        bottom: "10px",
                        left: "5px",
                        position: "fixed",
                        "z-index": 9999,
                    };

            // Si hay customStyle, reemplaza por completo el baseStyle
            const customStyle = this.selected_skin?.whats_app_mainframe?.style;

            return customStyle && Object.keys(customStyle).length > 0
                ? customStyle
                : baseStyle;
        },
        domain() {
            return this.$store.getters['getDomain'];
        },
        infoRouter() {
            return this.$store.getters['getInfoRouter'];
        },
        urlview() {
            if (!this.infoRouter?.category || !this.infoRouter?.url) return '';

            const { category, provider, url } = this.infoRouter;
            const token = this.user.token || this.user_demo?.token || '123456789';
            const site_id = this.user.site_id || this.user_demo?.site_id || '';
            const site = this.user.site || this.user_demo?.site || '';
            const user_id = this.user.user_data?.data?.user_id || this.user_demo?.user_data?.data?.user_id || '';
            const currency = this.user.user_data?.data?.currency || this.user_demo?.user_data?.data?.currency || '';
            const language = this.language || '';
            const domain1 = this.user.domain || '';

            switch (category) {
                case 'sport':
                    if (provider === 'jbetsv2') {
                        return `${url}&token=${token}${site_id}-${site}&playerId=${user_id}_${site_id}&language=${language}&currency=${currency}&url=${this.domain.split('admin.')[1]}`;
                    }
                    return provider !== 'jbets'
                        ? `${url}${this.user.token ? `&auth_token=${token}` : ''}&language=${language}`
                        : `${url}&token=${token}${site_id}&language=${language}`;
                case 'sportlive':
                    if (provider === 'jbetsv2') {
                        return `${url}&token=${token}${site_id}-${site}&playerId=${user_id}_${site_id}&language=${language}&currency=${currency}&url=${this.domain.split('admin.')[1]}`;
                    }
                    return `${url}&token=${token}${site_id}&language=${language}`;

                case 'esport':
                    return `${url}&token=${token}${site_id}-${site}&playerId=${user_id}_${site_id}&language=${language}&currency=${currency}&url=${this.domain.split('admin.')[1]}`;

                case 'lobby':
                    return `${url}&token=${(this.user.token ? this.user.token + this.user.site_id + '-' + this.user.site : '')}&playerId=${user_id}_${site_id}&language=${language}&currency=${currency}`;

                case 'casino':
                    let baseUrl = `${url}&token=${token}${site_id}-${site}&playerId=${user_id}_${site_id}&language=${language}&currency=${currency}`;
                    if (this.infoRouter?.id) {
                        let stringParamsArray = []
                        Object.keys(this.infoRouter.id).forEach(param => {
                            stringParamsArray.push(`${param}=${this.infoRouter.id[param]}`)
                        })
                        baseUrl += `&${stringParamsArray.join('&')}`; // Agrega el ID a la URL si existe
                    }
                    return baseUrl;
                case 'casino_live':
                    return `${url}&token=${token}${site_id}-${site}&playerId=${user_id}_${site_id}&language=${language}&currency=${currency}`;
                case 'crazzywin':
                    return `${url}&token=${token}${site_id}-${site}&playerId=${user_id}_${site_id}&language=${language}&currency=${currency}`;
                case 'hipicas':
                    return provider !== 'jbets'
                        ? `${url}&tokenUser=${token}${site_id}&tokenClient=72b0fc93-fdd1-4c08-b1fd-0be81726a5d2&lang=es&cashierUrl=${domain1}&homeUrl=${domain1}`
                        : `${url}&token=${token}${site_id}-${site}&playerId=${user_id}_${site_id}&language=${language}&currency=${currency}&url=${this.domain.split('admin.')[1]}`;
                default:
                    return url;
            }
        },
        language() {
            return this.$store.getters['getLanguage'];
        },
        contentHeight() {
            this.refreshHeight;
            let header_height = this.$store.getters["getHeaderHeight"];
            let screen_height = window.innerHeight;
            if (this.selected_skin.lobby) {
                return (screen_height - header_height) + "px";
            }
            else {
                return (screen_height - header_height - (this.selected_skin.skin_type === 'ganamos' && this.screen_width < 700 ? 70 : 0)) + "px";
            }
        },
        reloadIframe() {
            return this.$store.getters['getRechargeIframe']
        },
        headerHeight() {
            return this.$store.getters["getHeaderHeight"] + "px"
        },
        selected_skin() {
            return this.$store.getters['getCurrentSkin'];
        },
        // skin_charged() {
        //     return this.$store.getters['getSkinCharged'];
        // },
        user() {
            let data = this.$store.getters['getUserData'];
            return data;
        },
        user_demo() {
            let data = this.$store.getters['getUserDataDemo'];
            return data;
        }
    },
    created() {
        this.sizeControl();
        this.checkToken();
    },
    mounted() {
        window.addEventListener('resize', () => { this.sizeControl(); });
        window.addEventListener("message", (event) => {
            let view = event.data.view;
            if (!view) {
                return;
            }
            const viewMap = {
                "bingo": "esport",
                "crazywin": "crazzywin",
                "main": "sport"
            };
            view = viewMap[view] || view;
            if (["casino_live", "casino", "hipicas", "esport", "poker", "crazzywin", "openCasinoGame", "openCasinoGameFromLobby"].includes(view) &&
                this.user.token === "") {
                this.$root.$emit('openLogin');
            }
            else if (view === 'openCasinoGame') {
                window.location.href = event.data.url;
            }
            else if (view === 'openCasinoGameFromLobby' && event?.data?.data) {
                this.$store.dispatch("changeView", event);
            }
            else {
                this.$store.dispatch("changeView", view);
            }

        }, false);
    },
    methods: {
        async checkToken() {
            if (this.$store.getters['getUserData'].user_data.data && this.user.token != "" && this.selected_skin.skin_type !== 'altenar') {
                this.$store.dispatch('getProfile', {
                    token: this.user.token,
                    site_id: this.user.site_id,
                    site: this.user.site,
                    prefix: this.user.prefix,
                    playerId: this.user.user_data?.data?.user_id,
                    source: "main"
                });
            }
        },
        sizeControl() {
            this.screen_width = window.innerWidth;
            this.refreshHeight++;
        }
    },
    watch: {
        infoRouter(newVal) {
            if (Array.isArray(newVal)) {
                console.warn("infoRouter no debería ser un array:", newVal);
                return;
            }
        }

    }
}
</script>